import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import FormattedCurrencyValue from '../../fields/number/FormattedCurrencyValue';
import DATA_MINING_CONTROLLER from '../../../controllers/dataMining';
import { TableConfig } from '../../../utils/appConfig';
import NoData from '../../page/NoData';
import Pagination from '../../page/Pagination'
import InvoiceLines from '../reportDefinition/InvoiceLines.json';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../../utils/logger';
import ApplicationMessages from '../../inAppMessages/ApplicationMessages';
import ExportAll from '../../common/ExportAll';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import { ReportType } from '../../../utils/enums';

const log = new Logger('DATA_MINING_INVOICE_LINES_PAGE', LOG_LEVELS.DEBUG);

const FILE_NAME = 'DataMining.csv';

const InvoiceLinesColumnMapping = {
    "id": "Nr", "docID": "Doc ID", "invoiceNumber": "Invoice Number", "transactionDate": "Transaction Date",
    "invoiceDate": "Invoice Date", "documentType": "Document Type", "sapDocumentType": "SAP Document Type",
    "reporterID": "Reporter ID", "reporterName": "Reporter Name", "supplierID": "Supplier ID", "supplierName": "Supplier Name",
    "supplierCountry": "Supplier Country", "customerID": "Customer ID", "customerName": "Customer Name", "customerCountry": "Customer Country",
    "vatNumberUsedSupplier": "VAT Number Used Supplier", "vatNumberUsedByCustomer": "VAT Number Used By Customer",
    "countryVATNumberUsedSupplier": "Country VAT Number Used Supplier", "countryVATNumberUsedByCustomer": "Country VAT Number Used By Customer"
    , "lineVATCode": "Line VAT Code", "amount": "Amount", "amountVAT": "Amount VAT", "amountVATReversed": "Amount VAT Reversed"
    , "amountVATDeducted": "Amount VAT Deducted", "currency": "Currency", "referenceInvoiceNumber": "Reference Invoice Number", "shipToCountry": "Ship To Country"
    ,"dateOfSupply" : "Date Of Supply", "itemIdentifier" : "Item Identifier","documentIndicator" : "Document Indicator"
};

const DEFAULT_PAGINATION_CONFIG = {
    pageNumber: 1,
    pageSize: TableConfig.REPORT_LEVEL_ONE_PAGE_SIZE,
    page:0,
    startAt: 1
};

const NoDataComponent = props => (
    <NoData
        noDataText="transactionReports_NoData"
        {...props}
    />
);

export class InvoiceLinesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: 'Invoice lines'
            },
            pagination: DEFAULT_PAGINATION_CONFIG,
            loading: true
        };
        this.onFetchDataHandler = this.onFetchDataHandler.bind(this);
        this.handleExportAllToCSV = this.handleExportAllToCSV.bind(this);
        this.handleExportAllToCSVInclusiveELR = this.handleExportAllToCSVInclusiveELR.bind(this);
        this.getLanguageText = this.getLanguageText.bind(this);
        this.getToastDetails = this.getToastDetails.bind(this);
        this.handleToastClose = this.handleToastClose.bind(this);
        this.getStatusForToast = this.getStatusForToast.bind(this)
        this.getLanguageTextForElr = this.getLanguageTextForElr.bind(this);
        this.getToastDetailsElr = this.getToastDetailsElr.bind(this);
    }
    getParameters(selection, pagination) {
        let params = {
            startAt: pagination.startAt,
            pageSize: pagination.pageSize,
            dateType: selection.dateType,
            startDate: selection.startDate,
            endDate: selection.endDate,
            sortAscending: selection.sortAscending
        };
        return params;
    }

    getColumns() {
        var columnData = InvoiceLines;

        log.debug('render(): columnData', columnData);

        const columns = columnData.map((item, id) => {
            log.debug('render(): item', item, item.Accessor, item.Header);
            return {
                id: item.Accessor,
                Header: props => <LanguageStringResolver string={item.Header} />,
                accessor: ((item.Accessor === 'Amount') || (item.Accessor === 'Amount VAT') || (item.Accessor === 'Amount VAT Reversed')
                    || (item.Accessor === 'Amount VAT Deducted')) ?
                    d => <FormattedCurrencyValue value={d[item.Accessor]}></FormattedCurrencyValue> : item.Accessor,
                style: item.textAlign !== undefined ? { textAlign: "right" } : "",
                maxWidth: item.MaxWidth !== undefined ? item.MaxWidth : 1000,
            }
        })
        log.debug('render(): ', columns);
        return columns;
    }

    onFetchDataHandler(state) {
        log.debug('onFetchDataHandler(): ');
        let { page, pageSize } = state;
        pageSize = Object.is(pageSize, NaN) ? TableConfig.REPORT_LEVEL_ONE_PAGE_SIZE : pageSize;
        page = Object.is(page, NaN) ? 0 : page;
        const startAt = page * pageSize;
        let pagination = Object.assign({}, this.state.pagination, {
            pageNumber: page + 1,            
            page: page,
            pageSize: pageSize,
            startAt: startAt + 1
        });

         //To set default/hidden properties of react table
         if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page = 0;
        }
        this.setState({
            pagination: pagination,
            viewTableState: state,
            loading: true
        });

        this.props.doGetInvoiceLinesData(this.getParameters(this.props.filterCriteria, pagination), () => {
            let pagination = Object.assign({}, this.state.pagination);
            let invoiceData = this.props.invoiceData || [];
            let totalCount = (this.props.invoiceData && this.props.invoiceData.totalCount) || invoiceData.length;
            pagination.pages = pagination.pageSize === 0 ? totalCount : Math.ceil(totalCount / pagination.pageSize);
            this.setState({
                loading: false,
                pagination: pagination
            });
        });
    }
    generateExportAllRequestPayload() {
        const totalCount = this.props.invoiceData.totalCount;
        const customerId = this.props.customerId;
        const username = this.props.username;
        const reportType = ReportType.INVOICE_LINES;
        const params = {
            ...this.getParameters(this.props.filterCriteria, this.state.pagination),
            totalCount,
            customerId,
            username,
            reportType
        };
        return params;
    }

    handleExportAllToCSV() {
        const payload = this.generateExportAllRequestPayload();
        this.props.exportAllToCSV(payload);
    }
    
    handleExportAllToCSVInclusiveELR() {
        const payload = {
            ...this.generateExportAllRequestPayload(),
            includeElrStatus: true
        };
        this.props.exportAllElrToCSV(payload);
    }

    handleToastClose() {
        this.props.resetExportAllToast();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //when reportType is same and filters are updated/changed and clicked apply, need to call fetch data explicitely
        if (!nextProps.isReportTypeChanged && (nextProps.filterCriteria !== this.props.filterCriteria)) {
            this.props = nextProps;
            this.onFetchDataHandler(Object.assign({}, DEFAULT_PAGINATION_CONFIG, {pageSize: this.state.pagination.pageSize}));
        }
    }
    componentWillUnmount() {
        log.debug('componentWillUnmount()');
        log.clearDictionaryError(ALL_MESSAGES.REPORT_PAGE_SIZE_LOAD);
        this.props.doUnload();
    }

    getLanguageText(languages, key) {
        return this.props.showToast && languages && LANGUAGES_CONTROLLER.formatUtilFormatter(languages.data, key);
    }
    
    getLanguageTextForElr(languages, key) {
        return this.props.showToastElr && languages && LANGUAGES_CONTROLLER.formatUtilFormatter(languages.data, key);
    }

    getClass(invoiceData) {
        return _.isEmpty(invoiceData) ? 'mb30 hide-header' : 'mb30'
    }

    getToastDetails() {
        return (this.props.exportResponse && !this.props.exportResponse?.isSuccess) ? this.props.exportResponse?.error.message : this.getLanguageText(this.props.languages, 'viewTransmission_ExportAllToastDetails')
    }
    
    getToastDetailsElr() {
        return (this.props.exportResponse && !this.props.exportResponse?.isSuccess) ? this.props.exportResponse?.error.message : this.getLanguageTextForElr(this.props.languages, 'viewTransmission_ExportAllToastDetails')
    }
    
    getStatusForToast() {
        return (this.props.exportResponse && !this.props.exportResponse?.isSuccess) ? this.props.exportResponse?.error.type : 'success';
    }

    render() {
        log.debug('render() - props: ', this.props);
        log.setDictionaryMessage(ALL_MESSAGES.REPORT_PAGE_SIZE_LOAD);
        let pagination = this.state.pagination || {};
        if(this.viewTable?.state) {
            this.viewTable.state.page =pagination.page;
        }
        const columns = this.getColumns();
        let invoiceData = (this.props.invoiceData?.data) || [];
        for (let key in InvoiceLinesColumnMapping) {
            invoiceData = JSON.parse(JSON.stringify(invoiceData).split('"' + key + '":').join('"' + InvoiceLinesColumnMapping[key] + '":'));
        }

        let fileName = (this.state.selection?.reportType) ? this.state.selection.reportType.replace(' ', '') + '.csv' : FILE_NAME;

        return (
            <div data-test="component-invoice-lines-page">

                <ReactTable
                    manual
                    pages={pagination.pages || 1}
                    defaultPageSize={TableConfig.PAGINATION.REPORT_LEVEL_ONE_PAGE_SIZE}
                    pageSizeOptions={TableConfig.PAGINATION.REPORT_PAGE_SIZE_OPTIONS}
                    ref={ref => this.viewTable = ref}
                    minRows={0}
                    maxRows={0}
                    data={invoiceData}
                    columns={columns}
                    loading={this.props.loading} // Display the loading overlay when we need it
                    onFetchData={this.onFetchDataHandler} // Request new data when things change
                    sortable={false}
                    showPageJump={true}
                    NoDataComponent={NoDataComponent}
                    className={this.getClass(invoiceData)}
                    PaginationComponent={Pagination}
                    showPagination={invoiceData.length === 0 ? false : true}
                />
                <span className="mt10">
                      <ApplicationMessages
                          messageIds={[ALL_MESSAGES.REPORT_PAGE_SIZE_LOAD]}
                          messageType="applicationWarning"
                      />
                </span>
                {invoiceData?.length > 0 &&
                    <>
                        <CSVLink
                            data={sanitizeCsvData(invoiceData)}
                            filename={fileName}
                            className="button secondary">
                            <LanguageStringResolver string='viewTransmission_ExportToCSV' />
                        </CSVLink>
                        <ExportAll
                            exportLabel='viewTransmission_ExportAllToCSV'
                            exportClick={this.handleExportAllToCSV}
                            exportFor='ENABLE_EXPORT_ALL_INVOICE_LINES'
                            showToast={true}
                            elementType='btn'
                            toastType={this.getStatusForToast()}
                            toastTitle={this.getLanguageText(this.props.languages, 'viewTransmission_ExportAllToastTitle')}
                            toastDetails={this.getToastDetails()}
                            onCloseClick={this.handleToastClose}
                        />
                        <ExportAll
                            exportLabel='viewTransmission_ExportAllToCSVInclusiveELR'
                            exportClick={this.handleExportAllToCSVInclusiveELR}
                            exportFor='ENABLE_EXPORT_ALL_INVOICE_LINES_INCLUSIVE_ELR'
                            showToast={true}
                            elementType='btn'
                            testId="btn export-all-invoice-line-inclusive-elr"
                            toastType={this.getStatusForToast()}
                            toastTitle={this.getLanguageTextForElr(this.props.languages, 'viewTransmission_ExportAllToastTitle')}
                            toastDetails={this.getToastDetailsElr()}
                            onCloseClick={this.handleToastClose}
                        />
                    </>
                }
            </div>
        );
    }
}


InvoiceLinesPage.defaultProps = {
    filterCriteria: {},
    isReportTypeChanged: false
}

export function mapStateToProps(state) {
    return {
        languages: state.languages,
        invoiceData: (state.dataMining?.invoiceLinesOnly),
        showToast: (state.dataMining?.showToast),
        showToastElr: (state.dataMining?.showToastElr),
        exportResponse: state.dataMining?.exportResponse,
        customerId: state.authentication && state.authentication.data && state.authentication.data.customerId,
        username: (state.authentication && state.authentication.data && state.authentication.data.userName) || 'Unknown'
    }
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    dispatchProps.doGetInvoiceLinesData = (params, callback) => {

        log.debug('doGetInvoiceLinesData');
        dispatch(DATA_MINING_CONTROLLER.doGetInvoiceLinesData(params, callback));
    },
     dispatchProps.doUnload = () => {
        dispatch(DATA_MINING_CONTROLLER.doUnloadInvoiceLinesData());
    },
    dispatchProps.exportAllToCSV = (params) => {
        dispatch(DATA_MINING_CONTROLLER.doExportAllToCSV(params));
    }
    dispatchProps.exportAllElrToCSV = (params) => {
        dispatch(DATA_MINING_CONTROLLER.doExportAllElrToCSV(params));
    }
    dispatchProps.resetExportAllToast = () => {
        dispatch(DATA_MINING_CONTROLLER.deResetExportAllToast());
    }
    return dispatchProps;
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(InvoiceLinesPage);